import '@vaadin/custom-field';
import '@descope-ui/descope-combo-box';
import './descope-country-subdivision-city-field-internal';

import {
  componentName,
  CountrySubdivisionCityFieldClass,
} from './CountrySubdivisionCityFieldClass';

customElements.define(componentName, CountrySubdivisionCityFieldClass);

export { CountrySubdivisionCityFieldClass, componentName };
